import React, { useEffect, useState } from 'react'
import Switch from "react-switch";
import Colors from '../../../../Colors/Colors';
import axios from 'axios';
import { CompanyTitle } from '../../../../settings';

const Notifications = ({ user }) => {
    const [fromCareerPath, setFromCarrerPath] = useState(false)
    const [smsNotifications, setSmsNotifications] = useState(false)
    const [mobileNotifications, setMobileNotifications] = useState(false)
    const [newNotifications, setNewNotifications] = useState(false)
    let type = JSON.parse(localStorage.getItem('type'))
    const updateNewNotifications = () => {
        let data = {
            new_request_notification: newNotifications ? false : true
        }
        axios.put(`${process.env.REACT_APP_SERVER_PATH}/users/${+localStorage.getItem('id')}`, data).then((response) => {
            setNewNotifications(!newNotifications)
        }).catch(e => {
            console.log("error")
        })
    }
    const updateSmsNotifications = () => {
        let data = {
            sms_notification_alerts: smsNotifications ? false : true
        }
        axios.put(`${process.env.REACT_APP_SERVER_PATH}/users/${+localStorage.getItem('id')}`, data).then((response) => {
            setSmsNotifications(!smsNotifications)
        }).catch(e => {
            console.log("error")
        })
    }

    const updateCareerPathNotifications = () => {
        let data = {
            email_notification_alerts: fromCareerPath ? false : true
        }
        axios.put(`${process.env.REACT_APP_SERVER_PATH}/users/${+localStorage.getItem('id')}`, data).then((response) => {
            setFromCarrerPath(!fromCareerPath)
        }).catch(e => {
            console.log("error")
        })
    }
    const updateMobileNotifications = () => {
        let data = {
            mobile_notification_alerts: mobileNotifications ? false : true
        }
        axios.put(`${process.env.REACT_APP_SERVER_PATH}/users/${+localStorage.getItem('id')}`, data).then((response) => {
            setMobileNotifications(!mobileNotifications)
        }).catch(e => {
            console.log("error")
        })
    }
    const getUser = () => {
        axios.get(process.env.REACT_APP_SERVER_PATH + `/users/${+localStorage.getItem('id')}`)
            .then((response) => {
                if (type === 'professional') {
                    axios.get(process.env.REACT_APP_SERVER_PATH + `/professionals/${+localStorage.getItem('id')}`).then(response => {
                        setNewNotifications(response.data.User?.new_request_notification === 1 ? true : false)
                        setSmsNotifications(response.data.User?.sms_notification_alerts === 1 ? true : false)
                        setFromCarrerPath(response.data.User?.email_notification_alerts === 1 ? true : false)
                        setMobileNotifications(response.data.User?.mobile_notification_alerts === 1 ? true : false)

                    }).catch(e => {
                        console.log('Error in Professional Api in Professional Api')
                    })
                } else if (type === 'customer') {
                    axios.get(process.env.REACT_APP_SERVER_PATH + `/users/${+localStorage.getItem('id')}`).then(response => {
                        setNewNotifications(response.data.new_request_notification === 1 ? true : false)
                        setSmsNotifications(response.data.sms_notification_alerts === 1 ? true : false)
                        setFromCarrerPath(response.data.email_notification_alerts === 1 ? true : false)
                        setMobileNotifications(response.data.mobile_notification_alerts === 1 ? true : false)
                    }).catch(e => {
                        console.log('Error in Professional Api in Customer Api')
                    })
                }
            }).catch(e => {
                console.log("error occured");
            })
    }
    useEffect(() => {
        getUser()
    }, [])

    return (
        <div className="bg-white sm:p-4 md:p-8 rounded">
            <div className="mb-8 text-textFullDark font-bold text-2xl">
                Notification Settings
            </div>
            <label className="flex justify-between items-center">
                <span className="text-textFullDark">New Notifications Request</span>
                <Switch onChange={updateNewNotifications}
                    checked={newNotifications} uncheckedIcon={false}
                    checkedIcon={false}
                    height={24}
                    width={48}
                    onColor={Colors.blue}
                />
            </label>
            <hr className="my-4" />
            <label className="flex justify-between items-center">
                <span className="text-textFullDark">From {CompanyTitle}</span>
                <Switch onChange={updateCareerPathNotifications}
                    checked={fromCareerPath} uncheckedIcon={false}
                    checkedIcon={false}
                    height={24}
                    width={48}
                    onColor={Colors.blue} />
            </label>
            <hr className="my-4" />
            <label className="flex justify-between items-center">
                <span className="text-textFullDark">Mobile Notifications</span>
                <Switch onChange={updateMobileNotifications}
                    checked={mobileNotifications} uncheckedIcon={false}
                    checkedIcon={false}
                    height={24}
                    width={48}
                    onColor={Colors.blue} />
            </label>
            <hr className="my-4" />
            <label className="flex justify-between items-center">
                <span className="text-textFullDark">SMS Notifications</span>
                <Switch onChange={updateSmsNotifications}
                    checked={smsNotifications} uncheckedIcon={false}
                    checkedIcon={false}
                    height={24}
                    width={48}
                    onColor={Colors.blue} />
            </label>
            {/* {
                    arr.map((m) => {
                        return (
                            <div>
                                <Notification />
                                <hr className="my-4" />
                            </div>
                        )
                    })
                } */}
        </div>
    )
}

export default Notifications
